import { MermaidDiagram } from '@/components/MermaidDiagram';
import type { WorkflowDetail } from '../types';

interface SectionProps {
  workflow: WorkflowDetail;
}

export const DescriptionSection = ({ workflow }: SectionProps) => (
  <div className="animate-in fade-in-50 duration-200">
    <section className="space-y-6">
      <div>
        <h2 className="text-xl font-semibold mb-6">Overview</h2>
        <div className="prose prose-gray max-w-none dark:prose-invert lg:prose-lg">
          {workflow.description}
        </div>
      </div>

      {/* Flow Chart */}
      {workflow.flowChart && (
        <div>
          <h2 className="text-xl font-semibold mb-6">Workflow Diagram</h2>
          <div className="p-4 md:p-6 rounded-lg border bg-card shadow-sm">
            <div className="overflow-auto">
              <MermaidDiagram
                chart={workflow.flowChart}
                className="mermaid-diagram min-h-[300px] md:min-h-[400px] w-full"
              />
            </div>
          </div>
        </div>
      )}
    </section>
  </div>
);
